import { handleActions, createAction } from "redux-actions";
import { api } from "../../../services";
import { UserRatingStatus, RatingSortOption } from "../../../models/enums";

const RATINGS_GET = "RATINGS_GET";
const RATING_UPDATE_STATUS = "RATING_UPDATE_STATUS";

export const getRatings = createAction(
  RATINGS_GET,
  async (filters, page, itemPerPage) => {
    try {
      const result = await api.UserRating.adminSearch({
        ...filters,
        page,
        itemPerPage
      });
      return {
        page,
        itemPerPage,
        ratings: result.data || [],
        total: result.count || 0
      };
    } catch (e) {
      return { ratings: [], total: 0 };
    }
  }
);

export const updateRatingStatus = createAction(
  RATING_UPDATE_STATUS,
  async (ratingId, status, ratings, callback) => {
    try {
      await api.UserRating.setStatus(ratingId, { status });

      const updatedRatings = ratings.map(rating => {
        if (rating.id === ratingId) {
          return {
            ...rating,
            status
          };
        }

        return rating;
      });

      callback && callback();

      return { ratings: updatedRatings };
    } catch (e) {
      callback && callback();

      return null;
    }
  }
);

const defaultState = {
  page: 1,
  itemPerPage: 20,
  total: 0,
  ratings: [],
  filters: {
    status: UserRatingStatus.notReviewed,
    sortOption: RatingSortOption.Oldest
  }
};

const updateState = (state, { payload }) => ({
  ...state,
  ...payload
});

export default handleActions(
  {
    [RATINGS_GET]: updateState,
    [RATING_UPDATE_STATUS]: updateState
  },
  defaultState
);



// WEBPACK FOOTER //
// ./src/routes/Admin/ManageRatingsPage/ratings.ducks.ts